// const ApiUrl = "http://192.168.1.103/Jewellary/tirupur_jewellery";
// const ApiUrl = "http://192.168.1.103/Jewellary/tirupur_jewellery";
// const ApiUrl = "http://localhost";
//const ApiUrl = "http://192.168.1.36/Jewellary";
 const ApiUrl = "https://tirupurjewellery.in/";

export default ApiUrl;
